import React, { useState } from "react";
import "./ShowNumber.scss";
import { Link } from "components/core/Link";
import PropTypes from "prop-types";
import { LoadingBoxes, Phone } from "components/core/Icons";
import { Text } from "components/core/Typography";

function ShowNumber({
	color,
	underline,
	showIcon,
	phone,
	handleFetchNumber,
	iconSize = "xlarge",
	textFontWeight = "semiBold",
	showNumberOnly = false
}) {
	const [showNumber, setShowNumber] = useState();
	const [isLoading, setIsLoading] = useState(false);

	if (showNumberOnly && phone) {
		return (
			<div>
				<Link
					last
					size="small"
					color={color}
					hover={underline}
					underline={phone.formattedNumber && underline}
					href={`tel:${phone.number}`}
					weight={textFontWeight}
					className="dial-number-link"
				>
					{phone.formattedNumber}
				</Link>
			</div>
		);
	}

	return (
		<div>
			{!showNumber && (
				<Text
					color={color}
					size="small"
					weight={textFontWeight}
					className="custom-label"
					onClick={async () => {
						setIsLoading(true);
						setShowNumber(true);
						try {
							await handleFetchNumber("");
						} finally {
							setIsLoading(false);
						}
					}}
				>
					{showIcon && (
						<Phone
							data-testid="phone-icon"
							size="xlarge"
						/>
					)}
				</Text>
			)}
			{showNumber && isLoading && (
				<span className="fetch-phone-loading">
					<LoadingBoxes
						size="large"
						primaryColor="blue"
					/>
				</span>
			)}
			{showNumber && !isLoading && phone && (
				<Link
					last
					size="small"
					color={color}
					hover={underline}
					underline={phone.formattedNumber && underline}
					href={`tel:${phone.number}`}
					weight={textFontWeight}
					className="dial-number-link"
					icon={
						showIcon && (
							<Phone
								data-testid="phone-icon"
								size={iconSize}
							/>
						)
					}
				>
					{phone.formattedNumber}
				</Link>
			)}
		</div>
	);
}

ShowNumber.propTypes = {
	showIcon: PropTypes.bool,
	underline: PropTypes.bool,
	color: PropTypes.oneOf(["blue", "white"]),
	phone: PropTypes.shape({
		formattedNumber: PropTypes.string,
		number: PropTypes.string
	}),
	handleFetchNumber: PropTypes.func,
	showNumberOnly: PropTypes.bool,
	textFontWeight: PropTypes.string,
	iconSize: PropTypes.oneOf([
		"xsmall",
		"small",
		"medium",
		"large",
		"xlarge",
		"xxlarge",
		"huge",
		"fill"
	]),
};

export default ShowNumber;
